import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

import { inputSearch } from "_constants";
import { useEffect, useRef } from "react";
import { useAppDispatch } from "store/store";
import { setSearchTermUtenti } from "store/slicer/GestioneUsersSlice";
import { useDebounce, useUnmountEffect } from "primereact/hooks";

export const InputSearchUsers = () => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, debouncedValue, setInputValue] = useDebounce("", 500);

  const handleChange = (e: any) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    if (debouncedValue !== null && debouncedValue !== undefined) {
      dispatch(setSearchTermUtenti(debouncedValue));
    }
  }, [debouncedValue, dispatch]);

  useUnmountEffect(() => {
    dispatch(setSearchTermUtenti(""));
  });

  return (
    <IconField iconPosition="left">
      <InputIcon className="cta pi pi-search"></InputIcon>
      <InputText
        ref={inputRef}
        v-model="value1"
        placeholder={inputSearch}
        value={inputValue}
        onChange={handleChange}
        className="width-100"
      />
    </IconField>
  );
};
